"use client";

import * as React from "react";
import { InfoIcon } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@components/ui/tooltip";

import { TooltipArrow } from "@radix-ui/react-tooltip";

interface TooltipProps {
  text: string | React.ReactNode;
  customClass?: string;
}

const InfoTooltip: React.FC<TooltipProps> = ({ text, customClass = "" }) => {
  return (
    <>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <InfoIcon size={14} className={customClass} />
          </TooltipTrigger>
          <TooltipContent
            side="bottom"
            collisionPadding={{ left: 200, right: 200 }}
          >
            <p className="text-xs text-left max-w-80 text-wrap">{text}</p>
            <TooltipArrow className="TooltipArrow" />
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </>
  );
};

export default InfoTooltip;
